import PropTypes from 'prop-types';
import classnames from 'classnames';

// app
import styles from './Loader.styles';
// mui
import { makeStyles, CircularProgress, Typography } from '@material-ui/core';

LoaderView.propTypes = {
  message: PropTypes.string,
  visible: PropTypes.bool,
  absolute: PropTypes.bool,
  panel: PropTypes.bool,
  navExpanded: PropTypes.bool,
  sidebarExpanded: PropTypes.bool,
};

export function LoaderView({ message, visible, absolute, panel, navExpanded, sidebarExpanded }) {
  const classes = makeStyles(styles, { name: 'Loader' })({ visible, absolute, panel, navExpanded, sidebarExpanded });

  return (
    <div className={classnames(classes.root)} data-testid="loader">
      <CircularProgress size={32} data-testid="loading" />
      {message && (
        <Typography variant="body2" className={classes.text}>
          {message}
        </Typography>
      )}
    </div>
  );
}
